var _rect, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ill_success",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 120,
    height: 120,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Border",
    transform: "translate(32 32)",
    fill: "#1bad7f",
    stroke: "#1bad7f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M392.658,25.977l7.472,7.472,12.686-12.686",
    transform: "translate(-343.237 32.894)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllSuccess);
export default __webpack_public_path__ + "static/media/ill_success.3d704ad88103d5a2fd06d789f45ae43b.svg";
export { ForwardRef as ReactComponent };